var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toaster',{attrs:{"has-undo":""},on:{"undo-action":_vm.undoAction,"close-toaster":_vm.closeToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v(_vm._s(_vm.toasterText))]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }